import request from '@/utils/https';
//用户预约1-课程列表
export function getCourseList() {
    return request({
      url: `/edu/web/appointment/getCourseList`,
      method: 'get',
    });
  }
 // 用户预约2-根据学科id 课程id 查询章节及课件列表
export const listAll = (data) => {
    return request({
      url: `/edu/web/appointment/listAll`,
      method: 'post',
      data
    });
  }
  //用户预约3-陪练列表
export function getTeacherList() {
    return request({
      url: `/edu/web/appointment/getTeacherList`,
      method: 'get',
    });
  }
  //用户预约4-查询陪练预约信息（根据传入时间+7）
  export const getTeacherAppointInfo = (data) => {
    return request({
      url: `/edu/web/appointment/getTeacherAppointInfo`,
      method: 'post',
      data
    });
  }
  //用户预约5-预约陪练/edu/web/appointment/addAppointment

    export const addAppointment = (data) => {
    return request({
      url: `/edu/web/appointment/addAppointment`,
      method: 'post',
      data
    });
  }
  //获取消息通知列表/edu/web/message/list/{userId}

  export function getNotificaList(params) {
    return request({
      url: `/message/notifyMessage/my-page`,
      method: 'get',
      params
    });
  }

// 站内信标记为已读 /message/notifyMessage/update-read
export const updateRead = (params) => {
    return request({
      url: `/message/notifyMessage/update-read`,
      method: 'put',
      params
    });
  }

  // 所有站内信标记为已读 /message/notifyMessage/update-all-read
export const updateReadAll = (params) => {
    return request({
      url: `/message/notifyMessage/update-all-read`,
      method: 'put',
      params
    });
  }

  // 获取当前用户未读的站内信数量 /message/notifyMessage/get-unread-count
export const getUnreadCount = () => {
    return request({
      url: `/message/notifyMessage/get-unread-count`,
      method: 'get',
    });
  }
